import React from 'react'
import "../styles/Home.css";
import BannerImage from "../assets/welding2.jpg";


function Home() {
  return (
    <div className="home" style={{ backgroundImage: `url(${BannerImage})` }}>
    <div className="headerContainer">     
      <h1> THORNTON WELDING</h1>
      <p>Your one stop solution for all fabrication !!!</p>      
    </div>
    </div>
  )
}

export default Home
